/**
 * Tema VOVER
 * Cores da marca: azul escuro #21316a, azul claro/ciano #1155b3
 */

import { createTheme } from '@mui/material/styles';

export const voverTheme = createTheme({
  palette: {
    primary: {
      main: '#21316a',
      light: '#3d4d8a',
      dark: '#1a2854',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#24e2e4',
      light: '#5ae8ea',
      dark: '#1bb8ba',
      contrastText: '#1a1a1a'
    }
  }
});
